import { colors } from "../../../theme/theme";
import {
  STATUS_CHIP_CONFIG,
  PAYMENT_CHIP_CONFIG,
} from "./AppointmentDetailsModal.constants";

export const getStatusChipProps = (status, notes, isUpcomingSession) => {
  const key = status?.toLowerCase() || "";
  if (!isUpcomingSession) {
    return {
      label: status,
      $bgcolor: "transparent",
      $color: colors.primary,
      $border: `1px solid ${colors.primary}`,
    };
  }
  // Detect rescheduled appointments (cancelled with "Rescheduled" in notes)
  if (
    key === "cancelled" &&
    notes &&
    notes.toLowerCase().includes("rescheduled")
  ) {
    const config = STATUS_CHIP_CONFIG.rescheduled;
    return {
      label: config.label,
      $bgcolor: config.bgcolor,
      $color: config.color,
    };
  }

  const config = STATUS_CHIP_CONFIG[key];
  if (config) {
    return {
      label: config.label,
      $bgcolor: config.bgcolor,
      $color: config.color,
    };
  }
  return {
    label: status || "",
    $bgcolor: "transparent",
    $color: colors.primary,
    $border: `1px solid ${colors.primary}`,
  };
};

export const getPaymentStatusChipProps = (isPaid, isFreeConsultation, requiresPayment, isUpcomingSession) => {
  if (!isUpcomingSession) {
    return {
      label: isPaid ? "Paid" : isFreeConsultation ? "Free Consultation" : "Payment Pending",
      $bgcolor: "transparent",
      $color: colors.primary,
      $border: `1px solid ${colors.primary}`,
    };
  }
  if (isPaid) {
    const config = PAYMENT_CHIP_CONFIG.paid;
    return {
      label: config.label,
      $bgcolor: config.bgcolor,
      $color: config.color,
    };
  }
  if (isFreeConsultation) {
    const config = PAYMENT_CHIP_CONFIG.freeConsultation;
    return {
      label: config.label,
      $bgcolor: config.bgcolor,
      $color: config.color,
    };
  }
  if (requiresPayment) {
    const config = PAYMENT_CHIP_CONFIG.paymentPending;
    return {
      label: config.label,
      $bgcolor: config.bgcolor,
      $color: config.color,
    };
  }
  return null;
};
